import { Inject, Injectable } from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';

export interface ValidationError {
  propertyName: string;
  errorMessage: string;
  errorCode?: string;
  attemptedValue?: string | number;
}
export interface ServerErrors {
  [key: string]: string[]
}

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
}

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  constructor(private snackBar: MatSnackBar) { }

  /**
   * Handels validation errors from API
   * @param ValidationError Error object from fluentValidation
   * @param displaySnackBar Whether to display error in snackBar
   * @returns ValidationResult object
  */
  handleValidationErrors(validationErrors: ValidationError[], displaySnackBar: boolean = true): ValidationResult {
    const result: ValidationResult = {
      isValid: true,
      errors: []
    };

    if (!validationErrors.length) return result;

    if (validationErrors) {
      result.isValid = false;
      result.errors = validationErrors
    }


    if (displaySnackBar && result.errors.length > 0) {
      this.showValidationSnackBar(result.errors);
    }
    return result;
  }
  /**
   *  Display validation errors in snackbar
   *  @param errors List of validtaion errors
   */
  showValidationSnackBar(errors: ValidationError[]): void {
    let message = "";

    if (errors.length > 1) {
      message = `${errors.length} validation errors found. Please check your input:\n`;
      this.showSnackBar(message, 'error-snackbar');
    }
    errors.forEach(err => {
      message += err.errorMessage;
      message += '\n';

    })
    this.showSnackBar(message, 'error-snackbar');
  }

  /**
   * @param message Message to display
   * @param panelClass CSS class for style
   * @param duration Duration in milliseconds
   * */
  showSnackBar(message: string, panelClass: string = '', duration: number = 5000): void {
    this.snackBar.open(message, 'Close', {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: panelClass
    });
  }
}

